export default "__VITE_ASSET__DhTh4nzs__"